<template>
  <div class="wrapper">
    <Header></Header>
    <Sidebar></Sidebar>
    <div class="comp-box">
      <!-- <Tags></Tags> -->
      <transition name="move" mode="out-in">
        <component :is="currentComp" class="comp"></component>
      </transition>
    </div>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Sidebar from './components/Sidebar.vue'
import Personal from '@/views/personal'
import App from '@/views/organization-manage'
import Role from '@/views/role-permissions'
const moudles = require.context('@/views/user-config', false, /\.vue$/)
const components = moudles.keys().reduce((sum, item) => {
  let name = item.replace('./', '').replace('.vue', '')
  sum[name] = moudles(item).default
  return sum
}, {})

export default {
  data() {
    return {
      backPath: null
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      let pathArr = to.path.split('/'), path = from.path;
      pathArr = pathArr.slice(0, pathArr.length - 1)
      // pathArr[pathArr.length - 1] = ''
      if (!from.path || path == '/') {
        path = pathArr.join('/') 
        + '/organ-management' // 返回上一层会因为权限控制影响跳转失败 -AI
      } else path = from.path
      // console.log(pathArr, path);
      // console.log(to, '---t')
      console.log(from, '------f')
      !from.path.includes('user-config') && (vm.backPath = path);
    })
  },
  watch: {
    backPath(n) {
      // console.log(n, '--');
    }
  },
  components: {
    Header,
    Sidebar,
    ...components,
    Personal,
    App,
    Role
  },
  computed: {
    currentComp() {
      if (!this.$route.query.menu) {
        this.$route.query.menu = 'organTree'
      }
      return this.$route.query.menu || 'organTree'
    }
  }
}
</script>

<style scoped>
.wrapper {
  width: 100%;
  height: 100vh;
  background: #f2f3f4;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
}
.comp-box {
  position: absolute;
  left: 260px;
  right: 10px;
  top: 80px;
  height: calc(100vh - 88px);
  padding-bottom: 30px;
  transition: left 0.3s ease-in-out;
  overflow: auto;
  box-sizing: rgb(29, 17, 17) box;
  background: #fff;
}
.comp {
  padding: 16px;
}

/* .main-content {
  width: 100%;
  height: calc(100vh - 88px);
  overflow: auto;
  padding: 16px;
  box-sizing: rgb(29, 17, 17)box;
  background: red!important;
} */

.content-collapse {
  left: 65px;
}
.move-enter-active,
.move-leave-active {
  transition: all 0.5s;
}

.move-enter,
.move-leave {
  opacity: 0;
}
</style>
